export default "__VITE_ASSET__DQJOJCm8__"